var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasoline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4261 28.4468V1.89362C22.4261 1.51064 22.3622 1 22.0431 1H5.44733C5.12818 1 4.55371 1.51064 4.55371 1.89362V28.4468H22.4261Z",
    stroke: "#D3D8E2",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H8V14H13.5H19V5Z",
    stroke: "#D3D8E2",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6172 9.55313C22.6172 9.55313 24.3406 10.1276 24.3406 11.6595C24.3406 13.1276 24.3406 12.1063 24.3406 12.1063V18.4893C24.3406 18.4893 24.3406 20.851 26.447 20.851C28.5534 20.851 28.1704 18.9999 28.1704 18.9999V6.99994C28.1704 6.99994 28.3619 4.57441 25.4257 4.31909",
    stroke: "#D3D8E2",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8935 10.1914C27.6691 10.1914 28.2978 9.56274 28.2978 8.78719C28.2978 8.01164 27.6691 7.38293 26.8935 7.38293C26.118 7.38293 25.4893 8.01164 25.4893 8.78719C25.4893 9.56274 26.118 10.1914 26.8935 10.1914Z",
    stroke: "#D3D8E2",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasoline);
export default __webpack_public_path__ + "static/media/Gasoline.b65dcaa5.svg";
export { ForwardRef as ReactComponent };